import { ExportFormat } from '../utils/exportCitations';

export interface ExportFormatOption {
  format: ExportFormat;
  label: string;
}

export const EXPORT_FORMATS: ExportFormatOption[] = [
  {
    format: 'RIS',
    label: 'Download as RIS (for EndNote, Mendeley, Zotero, etc.)',
  },
  { format: 'ACS', label: 'Download as ACS' },
  { format: 'APA', label: 'Download as APA' },
  { format: 'BibTeX', label: 'Download as BibTeX/LaTeX' },
  { format: 'Chicago', label: 'Download as Chicago' },
  { format: 'Harvard', label: 'Download as Harvard' },
  { format: 'IEEE', label: 'Download as IEEE' },
  { format: 'MLA', label: 'Download as MLA' },
  { format: 'Vancouver', label: 'Download as Vancouver' },
];
